<template>
  <div class="inline-block min-width-full overflow-hidden rounded-lg shadow bg-white p-4">
    <b-row>
      <b-form-group label="제목" label-cols-sm="3" label-size="sm">
        <b-form-input
          id="inline-form-input-name"
          class=" mr-sm-2 md-4"
          placeholder="제목을 입력해주세요."
          v-model="title"
        />
      </b-form-group>
      <b-form-group label="접속 링크" label-cols-sm="3" label-size="sm">
        <b-form-input
          id="inline-form-input-name"
          class=" mr-sm-2 md-4"
          placeholder="링크를 입력해주세요."
          v-model="linkKey"
          :disabled="!!id"
        />
      </b-form-group>
      <b-form-group label="공지사항 노출 여부" label-cols-sm="3" label-size="sm">
        <b-form-radio-group
          v-model="publishStatus"
          :options="publishOptions"
          class="mb-3"
          value-field="item"
          text-field="name"
          disabled-field="notEnabled"
        />
      </b-form-group>
      <b-form-group label="메모" label-cols-sm="3" label-size="sm">
        <b-form-textarea
          id="textarea"
          v-model="memo"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
      </b-form-group>
    </b-row>
    <b-row>
      <div class="main-container w-100">
        <div class="editor-container editor-container_classic-editor" ref="editorContainerElement">
          <div class="editor-container__editor">
            <div ref="editorElement" class="ck-content">
              <ckeditor v-if="isLayoutReady" v-model="config.initialData" :editor="editor" :config="config" />
            </div>
          </div>
        </div>
      </div>
    </b-row>
    <b-row class="text-right inline-flex gap-2 justify-end items-center w-full my-3">
      <Button
        v-if="!id"
        :type="ButtonTypes.yellow"
        label="저장"
        :onClick="save"
        :full="false"
      />
      <Button
        v-if="!!id"
        :type="ButtonTypes.yellow"
        label="수정"
        :onClick="update"
        :full="false"
      />
    </b-row>
  </div>
</template>
<script>
import {ButtonTypes} from "@/util/enums";
import Button from "@/components/Button.vue";
import api from "@/api/api";
import translations from 'ckeditor5/translations/ko.js';
import 'ckeditor5/ckeditor5.css';
import {
  ClassicEditor,
  AccessibilityHelp,
  Alignment,
  Autoformat,
  AutoImage,
  Autosave,
  BalloonToolbar,
  BlockQuote,
  Bold,
  CloudServices,
  Essentials,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  Heading,
  Highlight,
  HorizontalLine,
  ImageBlock,
  ImageCaption,
  ImageInline,
  ImageInsert,
  ImageInsertViaUrl,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  LinkImage,
  List,
  ListProperties,
  MediaEmbed,
  Paragraph,
  PasteFromOffice,
  SelectAll,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  TodoList,
  Underline,
  Undo, PastePlainText, SimpleUploadAdapter
} from 'ckeditor5';

export default {
  computed: {
    ButtonTypes() {
      return ButtonTypes
    }
  },
  components: {Button},
  data() {
    return {
      isLayoutReady: false,
      config: {
        toolbar: {
          items: [
            'undo',
            'redo',
            '|',
            'heading',
            '|',
            'fontSize',
            'fontFamily',
            'fontColor',
            'fontBackgroundColor',
            'lineHeight', // 행간 추가
            'letterSpacing', // 자간 추가
            '|',
            'bold',
            'italic',
            'underline',
            '|',
            'horizontalLine',
            'link',
            'insertImage',
            'mediaEmbed',
            'insertTable',
            'blockQuote',
            '|',
            'special',
            'alignment',
            '|',
            'bulletedList',
            'todoList',
            'outdent',
            'indent',
            'lineHeight'
          ],
          shouldNotGroupWhenFull: true
        },
        plugins: [
          PasteFromOffice,
          PastePlainText,
          AccessibilityHelp,
          Alignment,
          Autoformat,
          AutoImage,
          Autosave,
          BalloonToolbar,
          BlockQuote,
          Bold,
          CloudServices,
          Essentials,
          FontBackgroundColor,
          FontColor,
          FontFamily,
          FontSize,
          Heading,
          Highlight,
          HorizontalLine,
          ImageBlock,
          ImageCaption,
          ImageInline,
          ImageInsert,
          ImageInsertViaUrl,
          ImageResize,
          ImageStyle,
          ImageTextAlternative,
          ImageToolbar,
          ImageUpload,
          Indent,
          IndentBlock,
          Italic,
          Link,
          LinkImage,
          List,
          ListProperties,
          MediaEmbed,
          Paragraph,
          PasteFromOffice,
          SelectAll,
          Table,
          TableCaption,
          TableCellProperties,
          TableColumnResize,
          TableProperties,
          TableToolbar,
          TextTransformation,
          TodoList,
          Underline,
          Undo,
          SimpleUploadAdapter
        ],
        balloonToolbar: [ 'fontSize',
          'fontFamily',
          'fontColor',
          'fontBackgroundColor', 'bold', 'italic', 'lineHeight', '|', 'link', 'insertImage', '|', 'bulletedList', 'numberedList'],
        fontFamily: {
          supportAllValues: true
        },
        simpleUpload: {
          // The URL that the images are uploaded to.
          uploadUrl: `${process.env.VUE_APP_API}/admin/notice/image`,

          // Enable the XMLHttpRequest.withCredentials property.
          withCredentials: true,

          // Headers sent along with the XMLHttpRequest to the upload server.
          headers: {
            Authorization: `Bearer ${localStorage.ACCESS_TOKEN}`
          }
        },
        fontSize: {
          options: [
            { title: '10px', model: '10px' },
            { title: '12px', model: '12px' },
            { title: '14px', model: '14px' },
            { title: 'Default', model: '16px' },
            { title: '18px', model: '18px' },
            { title: '20px', model: '20px' },
            { title: '22px', model: '22px' },
            { title: '24px', model: '24px' },
            { title: '32px', model: '32px' },
            { title: '36px', model: '36px' },
            { title: '40px', model: '40px' },
            { title: '44px', model: '44px' },
            { title: '48px', model: '48px' },
            { title: '50px', model: '50px' },
            { title: '54px', model: '54px' },
            { title: '58px', model: '58px' }
          ],
          supportAllValues: true
        },
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph'
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1'
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2'
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3'
            },
            {
              model: 'heading4',
              view: 'h4',
              title: 'Heading 4',
              class: 'ck-heading_heading4'
            },
            {
              model: 'heading5',
              view: 'h5',
              title: 'Heading 5',
              class: 'ck-heading_heading5'
            },
            {
              model: 'heading6',
              view: 'h6',
              title: 'Heading 6',
              class: 'ck-heading_heading6'
            },
          ]
        },
        image: {
          toolbar: [
            'toggleImageCaption',
            'imageTextAlternative',
            '|',
            'imageStyle:inline',
            'imageStyle:wrapText',
            'imageStyle:breakText',
            '|',
            'resizeImage'
          ],
          resizeOptions: [
            {
              name: 'resizeImage:original',
              value: null,
              label: 'Original'
            },
            {
              name: 'resizeImage:50',
              value: '50',
              label: '50%'
            },
            {
              name: 'resizeImage:75',
              value: '75',
              label: '75%'
            }
          ],
          upload: {
            types: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff']
          }
        },
        initialData: "",
        language: 'ko',
        link: {
          addTargetToExternalLinks: true,
          defaultProtocol: 'https://',
          decorators: {
            toggleDownloadable: {
              mode: 'manual',
              label: 'Downloadable',
              attributes: {
                download: 'file'
              }
            }
          }
        },
        list: {
          properties: {
            styles: true,
            startIndex: true,
            reversed: true
          }
        },
        placeholder: 'Type or paste your content here!',
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells', 'tableProperties', 'tableCellProperties']
        },
        translations: [translations]
      },
      editor: ClassicEditor,
      id: null,
      contentHtml: '',
      title: '',
      linkKey: '',
      memo: '',
      publishStatus: "UNPUBLISHED",
      publishOptions: [
        { item: "PUBLISHED", name: '노출' },
        { item: "UNPUBLISHED", name: '비노출' },
      ],
    }
  },
  mounted() {
    this.id = this.$route.params.id !== 'new' ? this.$route.params.id : null
    if (this.id) {
      this.findNotice(this.id)
    }
    this.isLayoutReady = true;
  },
  methods: {
    findNotice() {
      api.notice.findNotice(this.id, (response) => {
        const {title, linkKey, status, memo, contents} = response.data.data
        this.title = title
        this.linkKey = linkKey
        this.publishStatus = status
        this.memo = memo
        this.config.initialData= contents
      }, (error) => {
        console.log(error)
      })
    },
    update() {
      if (this.title.length === 0) {
        this.$toast.error('제목을 입력해주세요.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }

      this.loading = true
      api.notice.updateNotice({
        id: this.id,
        title: this.title,
        status: this.publishStatus,
        memo: this.memo,
        contents: this.config.initialData,
      }, (response) => {
        this.loading = false
        const query = {}
        if (this.$route.query.page) {
          query.page = this.$route.query.page
        }
        if (this.$route.query.keyword) {
          query.keyword = this.$route.query.keyword
        }
        if (this.$route.query.checkDeleted) {
          query.checkDeleted = this.$route.query.checkDeleted
        }
        this.$router.push({ path: '/notices', query: Object.keys(query).length > 0 ? query : undefined })
      }, (error) => {
        this.loading = false
        this.$toast.error(error.response.data.message,
          {
            position: "top-right",
            duration: 2000
          })
      })
    },
    save () {
      if (this.title.length === 0) {
        this.$toast.error('제목을 입력해주세요.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }

      if (this.linkKey.length === 0) {
        this.$toast.error('접속링크를 입력해주세요.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }

      const regex = /^[a-zA-Z0-9\-_]+$/

      if (!regex.test(this.linkKey)){
        this.$toast.error('링크를 확인해주세요.. 영어, 숫자, _, - 만 사용 가능합니다.',
          {
            position: "top-right",
            duration: 2000
          })
        return
      }

      this.loading = true
      
      api.notice.addNotice({
        title: this.title,
        linkKey: this.linkKey,
        status: this.publishStatus,
        memo: this.memo,
        contents: this.config.initialData,
      }, (response) => {
        this.loading = false
        const query = {}
        if (this.$route.query.page) {
          query.page = this.$route.query.page
        }
        if (this.$route.query.keyword) {
          query.keyword = this.$route.query.keyword
        }
        if (this.$route.query.checkDeleted) {
          query.checkDeleted = this.$route.query.checkDeleted
        }
        this.$router.push({ path: '/notices', query: Object.keys(query).length > 0 ? query : undefined })
      }, (error) => {
        this.loading = false
        this.$toast.error(error.response.data.message,
          {
            position: "top-right",
            duration: 2000
          })
      })
    },
  }
}
</script>
<style scoped>
.ck-content  hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

.ck-content  h6, .ck-content .h6,
.ck-content  h5, .ck-content .h5,
.ck-content  h4, .ck-content .h4,.ck-content  h3, .ck-content  .h3,
.ck-content  h2,.ck-content .h2,.ck-content  h1,.ck-content  .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

.ck-content  h1, .ck-content .h1 {
  font-size: 3.8rem !important;
}
.ck-content  h2, .ck-content  .h2 {
  font-size: 3.4rem;
}

.ck-content  h3, .ck-content  .h3 {
  font-size: 2.8rem;
}

.ck-content  h4, .ck-content  .h4 {
  font-size: 2.4rem;
}

.ck-content h5, .ck-content .h5 {
  font-size: 2rem;
}

.ck-content h6, .ck-content .h6 {
  font-size: 1.6rem;
}

.ck-content {
  font-size: 1.4rem;
}

.ck-content p {
  margin-top: 0;
  margin-bottom: 1rem;
}

:deep(.ck-editor__editable_inline) {
  min-height: 400px;
}

/* 글씨 크기 드롭다운 고정 높이 및 스크롤 (일반 툴바) */
:deep(.ck-dropdown__panel) {
  max-height: 200px !important;
  overflow-y: auto !important;
}

/* 글씨 크기 드롭다운 고정 높이 및 스크롤 (balloon toolbar) */
:deep(.ck-balloon-panel .ck-dropdown__panel) {
  max-height: 200px !important;
  overflow-y: auto !important;
}

/* 글씨 크기 드롭다운 내부 리스트 고정 높이 및 스크롤 */
:deep(.ck-dropdown__panel .ck-list),
:deep(.ck-balloon-panel .ck-dropdown__panel .ck-list) {
  max-height: 200px !important;
  overflow-y: auto !important;
}

/* 글씨 크기 선택 드롭다운의 모든 항목을 16px로 고정 */
:deep(.ck-dropdown__panel .ck-list__item),
:deep(.ck-balloon-panel .ck-dropdown__panel .ck-list__item) {
  font-size: 16px !important;
}

/* 글씨 크기 선택 드롭다운의 텍스트를 16px로 고정 */
:deep(.ck-dropdown__panel .ck-list__item .ck-button__label),
:deep(.ck-balloon-panel .ck-dropdown__panel .ck-list__item .ck-button__label) {
  font-size: 16px !important;
}

/* balloon toolbar 내부의 모든 드롭다운 패널 */
:deep(.ck-balloon-panel) {
  z-index: 9999;
}

:deep(.ck-balloon-panel .ck-dropdown__panel) {
  max-height: 200px !important;
  overflow-y: auto !important;
}

</style>